

import { DeletePlanDialog } from './DeletePlanDialog';
import { ConvertToTemplateDialog } from './ConvertToTemplateDialog';
import { GamePlanDetailsDialog } from './GamePlanDetailsDialog';
import { GamePlan } from '@/types/gamePlanner';

interface PlanDialogsProps {
  deleteDialogOpen: boolean;
  setDeleteDialogOpen: (open: boolean) => void;
  handleConfirmDelete: () => Promise<string | null>;
  
  detailsDialogOpen: boolean;
  setDetailsDialogOpen: (open: boolean) => void;
  editedName: string;
  editedDescription: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  handleSaveDetailsConfirm: () => Promise<GamePlan | null>;
  
  confirmTemplateDialogOpen: boolean;
  setConfirmTemplateDialogOpen: (open: boolean) => void;
  handleConfirmConvertToTemplate: () => Promise<GamePlan | null>;
}

export function PlanDialogs({
  deleteDialogOpen,
  setDeleteDialogOpen,
  handleConfirmDelete,
  
  detailsDialogOpen,
  setDetailsDialogOpen,
  editedName,
  editedDescription,
  onNameChange,
  onDescriptionChange,
  handleSaveDetailsConfirm,
  
  confirmTemplateDialogOpen,
  setConfirmTemplateDialogOpen,
  handleConfirmConvertToTemplate
}: PlanDialogsProps) {
  return (
    <>
      <DeletePlanDialog 
        open={deleteDialogOpen} 
        onOpenChange={setDeleteDialogOpen} 
        onConfirmDelete={handleConfirmDelete}
      />

      <ConvertToTemplateDialog 
        open={confirmTemplateDialogOpen} 
        onOpenChange={setConfirmTemplateDialogOpen} 
        onConfirmConvert={handleConfirmConvertToTemplate}
      />

      <GamePlanDetailsDialog 
        open={detailsDialogOpen}
        onOpenChange={setDetailsDialogOpen}
        editedName={editedName}
        editedDescription={editedDescription}
        onNameChange={onNameChange}
        onDescriptionChange={onDescriptionChange}
        onSave={handleSaveDetailsConfirm}
      />
    </>
  );
}
